import React from 'react';

const Buymeacoffee = () => {
  return (
      <a
          href="https://coff.ee/j.uni"
          target="_blank"
          rel="noopener noreferrer"
          style={{
              display: 'inline-block',
              padding: '10px 20px',
              backgroundColor: '#FFDD00',
              color: '#000',
              borderRadius: '8px',
              fontWeight: 'bold',
              textDecoration: 'none',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              fontSize: "0.85em",
              textAlign: "center"
          }}
      >
          ☕ Buy me a coffee
      </a>

  );
};

export default Buymeacoffee;
